module.exports = __webpack_public_path__ + "img/logo.3dec299a.png";